import ClickToCall from './ClickToCall'

export default ClickToCall
